import React, { useEffect, useState } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { Navigation } from './components/Navigation';
import { HeroBanner } from './components/HeroBanner';
import { TrustBar } from './components/TrustBar';
import { CategoryGrid } from './components/CategoryGrid';
import { WhyChooseUs } from './components/WhyChooseUs';
import { SizingHelp } from './components/SizingHelp';
import { Testimonials } from './components/Testimonials';
import { SEOContent } from './components/SEOContent';
import { NewsletterSignup } from './components/NewsletterSignup';
import { Footer } from './components/Footer';
import { FAQPage } from './components/FAQPage';
import { SizeChartPage } from './components/SizeChartPage';
import { AboutPage } from './components/AboutPage';
import { MailingListPage } from './components/MailingListPage';
import { ContactPage } from './components/ContactPage';
import { CustomOrdersPage } from './components/CustomOrdersPage';
import { ReturnsPage } from './components/ReturnsPage';
import { CheckoutPage } from './components/CheckoutPage';
import { ComingSoonPage } from './components/ComingSoonPage';
import { HowToOrderPage } from './components/HowToOrderPage';
import { WholesalePage } from './components/WholesalePage';
import { ShippingPage } from './components/ShippingPage';
import { PrivacyPolicyPage } from './components/PrivacyPolicyPage';
import { SwitchplatesPage } from './components/SwitchplatesPage';
import { ProductDetailPage } from './components/ProductDetailPage';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.hash || '#/');
  useEffect(() => {
    const onHashChange = () => {
      setCurrentPath(window.location.hash || '#/');
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  const basePath = currentPath.split('?')[0];
  const renderPage = () => {
    switch (basePath) {
      case '#/faq':
        return <FAQPage data-id="element-0" />;
      case '#/size-chart':
        return <SizeChartPage data-id="element-1" />;
      case '#/about':
        return <AboutPage data-id="element-2" />;
      case '#/mailing-list':
        return <MailingListPage data-id="element-3" />;
      case '#/contact':
        return <ContactPage data-id="element-4" />;
      case '#/custom-orders':
        return <CustomOrdersPage data-id="element-5" />;
      case '#/returns':
        return <ReturnsPage data-id="element-6" />;
      case '#/checkout':
        return <CheckoutPage data-id="element-7" />;
      case '#/switchplates':
        return <SwitchplatesPage data-id="element-8" />;
      case '#/product':
        return <ProductDetailPage data-id="element-9" />;
      case '#/reviews':
        return <ComingSoonPage title="Reviews" data-id="element-10" />;
      case '#/how-to-order':
        return <HowToOrderPage data-id="element-11" />;
      case '#/wholesale':
        return <WholesalePage data-id="element-12" />;
      case '#/shipping':
        return <ShippingPage data-id="element-13" />;
      case '#/privacy':
        return <PrivacyPolicyPage data-id="element-14" />;
      case '#/wholesale-signup':
        return <ComingSoonPage title="Wholesale Signup" data-id="element-15" />;
      case '#/support':
        return <FAQPage data-id="element-16" />;
      default:
        return <>
            <HeroBanner data-id="element-17" />
            <TrustBar data-id="element-18" />
            <CategoryGrid data-id="element-19" />
            <WhyChooseUs data-id="element-20" />
            <SizingHelp data-id="element-21" />
            <Testimonials data-id="element-22" />
            <SEOContent data-id="element-23" />
          </>;
    }
  };
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-24">
      <AnnouncementBar data-id="element-25" />
      <Header data-id="element-26" />
      <Navigation data-id="element-27" />

      <main className="flex-grow" data-id="element-28">
        {renderPage()}
        <NewsletterSignup data-id="element-29" />
      </main>

      <Footer data-id="element-30" />
    </div>;
}